import { render } from "./KnownRegistration.vue?vue&type=template&id=b8a10c70&scoped=true&ts=true"
import script from "./KnownRegistration.vue?vue&type=script&lang=ts"
export * from "./KnownRegistration.vue?vue&type=script&lang=ts"

import "./KnownRegistration.vue?vue&type=style&index=0&id=b8a10c70&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a10c70"]])

export default __exports__